// extracted by mini-css-extract-plugin
export var displayNone = "_m9-6";
export var imgContainer = "_m9-2";
export var overflowHidden = "_m9-3";
export var productInfoCardButtonContainer = "_m9-5";
export var productTitleText = "_m9-4";
export var rightArrow = "_m9-1";
export var rightArrowContainer = "_m9-0";